export default "__VITE_ASSET__c8532651__"